import React from "react";

export default function RoamingPackCountriesShimmer() {

  return (
    <div className="position-relative category-tabs shimmer-effect">
      <section className="corp-abt-thumb-slider pack-tab-swiper borderradius-bg">
        <div className="pse_sm">
          <div className="flex_grp_align_center search_input_grp mt-3">
            <div className="input_icon_search input_icon_search-v1 left-icon flex1 shimmerBG shimmer-img-xs" >
              <input
                type="text"
                maxlength="30"
                className="form-control shimmerBG shimmer-img-xs "
                // placeholder="Search Countries"
                data-bs-toggle="offcanvas"
                data-bs-target="#search-results"
                aria-controls="offcanvasBottom"
                value=""
              />
              <button className="pe-none">
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="container-tab position-relative">
        <div className="swiper-container tabs-thumbs c-about-thumbs">
          <ul
            className="cs_tabs white-bg m-0 box-shadow-comp nav nav-tabs"
            role="tablist"
          >
            <li className="nav-item w-25" role="presentation">
                <div className="shimmer-button-xs border-radious30 shimmer-h30 w-100 shimmerBG"></div>
            </li>
            <li className="nav-item w-25" role="presentation">
                <div className="shimmer-button-xs border-radious30 shimmer-h30 w-100 shimmerBG"></div>
            </li>
          </ul>
          
        </div>
      </div>
    </div>
  );
}
